import React from 'react';

const WaterIcon = ({ className }) => (
  <svg
    width="25"
    height="29"
    viewBox="0 0 25 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.76562 17.6625L5.625 25.5H19.375L20.2688 17.25H19.9594C19.0885 17.25 18.2922 17.187 17.5703 17.0609C16.8484 16.9349 15.8688 16.6885 14.6313 16.3219C14.1042 16.1615 13.5542 16.0469 12.9813 15.9781C12.4083 15.9094 11.8354 15.875 11.2625 15.875C10.0938 15.875 8.96511 16.024 7.87656 16.3219C6.78802 16.6198 5.75104 17.0667 4.76562 17.6625ZM4.42188 14.7063C5.49896 14.1792 6.61615 13.7839 7.77344 13.5203C8.93073 13.2568 10.1052 13.125 11.2969 13.125C11.9844 13.125 12.6661 13.1708 13.3422 13.2625C14.0182 13.3542 14.6885 13.4917 15.3531 13.675C16.499 13.9958 17.3755 14.2135 17.9828 14.3281C18.5901 14.4427 19.2375 14.5 19.925 14.5H20.5781L21.7812 3.5H3.21875L4.42188 14.7063ZM5.59063 28.25C4.88021 28.25 4.26719 28.0208 3.75156 27.5625C3.23594 27.1042 2.94375 26.5198 2.875 25.8094L0.125 0.75H24.875L22.125 25.8094C22.0562 26.5198 21.7641 27.1042 21.2484 27.5625C20.7328 28.0208 20.1198 28.25 19.4094 28.25H5.59063Z"
      fill="currentColor"
    />
  </svg>
);

export default WaterIcon;
